import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import * as React from 'react';

import Expandable from '../../components/Expandable/Expandable';
import LangEnum from '../../lang/LangEnum';
import useTeceoStyles from '../../useTeceoStyles';
import { useTranslation } from '../translation/TranslationContext';

type SettingContainerProps = {
  title: string | LangEnum;
  description?: LangEnum;
  renderInfo?: () => React.ReactElement;
  children: React.ReactElement | React.ReactElement[];
};

const SettingContainer = ({ title, description, children, renderInfo }: SettingContainerProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();

  return (
    <Stack spacing={2}>
      <Expandable titleVariant="h4" title={title}>
        {description ? (
          <Typography color="textSecondary" className={teceoClasses.lowercase}>
            {translate(description)}
          </Typography>
        ) : (
          renderInfo?.()
        )}
      </Expandable>
      {children}
    </Stack>
  );
};

export default SettingContainer;
